const RISKS_URL_TEMPLATE = `${process.env.VUE_APP_PT_RISK_URL}/risks/edit/{externalId}`;
const OPPORTUNITIES_URL_TEMPLATE = `${process.env.VUE_APP_PT_RISK_URL}/opportunities/edit/{externalId}`;
const DELETED_ID_REGEX = / -\s*Deleted\s*$/i;
const MSPT_ID_REGEX = /-M$/i;
const STATUTORY_ID_REGEX = /-S$/i;
const OPPORTUNITY_ID_REGEX = /-O$/i;
const UNICODE_ZERO_WIDTH_SPACE_REGEX = /\u200B/g;

export function getExternalItemDeepLink(displayId: string): string | null {
    const id = (displayId || '').trim().replace(UNICODE_ZERO_WIDTH_SPACE_REGEX, '');
    if (!id || DELETED_ID_REGEX.test(id) || MSPT_ID_REGEX.test(id) || STATUTORY_ID_REGEX.test(id)) {
        return null;
    }

    const isOpportunity = OPPORTUNITY_ID_REGEX.test(id);

    if (isOpportunity) {
        return OPPORTUNITIES_URL_TEMPLATE.replace('{externalId}', id);
    }

    return RISKS_URL_TEMPLATE.replace('{externalId}', id);
}
